
function uniques(items, identity=((item) => item)) {
    const set = new Set();
    const result = [];
    for (const item of items) {
        const id = identity(item);
        if (!set.has(id)) {
            set.add(id);
            result.push(item);
        }
    }
    return result;
}

export default uniques;

